// extracted by mini-css-extract-plugin
var _1 = "ra-card-artist-body";
var _2 = "ra-card-artist";
var _3 = "ra-card-artist-details";
var _4 = "ra-card-artist-footer";
var _5 = "ra-card-artist-image";
var _6 = "ra-card-artist-info";
var _7 = "ra-card-artist-style-1";
var _8 = "ra-card-artist-style-2";
var _9 = "ra-card-artist-title";
export { _1 as "cardArtistBodyCls", _2 as "cardArtistCls", _3 as "cardArtistDetailsCls", _4 as "cardArtistFooterCls", _5 as "cardArtistImageCls", _6 as "cardArtistInfoCls", _7 as "cardArtistStyle1Cls", _8 as "cardArtistStyle2Cls", _9 as "cardArtistTitleCls" }
